import Footer from './Footer';
import './style/footer.less';

export default Footer;
